import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

class ReCaptchaFormItem extends React.Component {
  constructor(props) {
    super(props);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  verifyCallback(value) {
    const { onChange } = this.props;
    onChange(value);
  }

  render() {
    return (
      <ReCAPTCHA
        sitekey="6LdQ1wAdAAAAADMaGVi-HSvnsbwyEqaipLEnvIv3"
        onChange={this.verifyCallback}
      />
    );
  }
}

export default ReCaptchaFormItem;
